import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IconButtonWrapper } from '~/components/common';

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    padding: calc(${theme.layout.chat_header_height} + 16px)
      ${theme.layout.section_side} 16px;
  `}
`;

export const DetailTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_2};
    ${theme.fontStyle.text.body16_bold};
  `}
`;

export const UploadImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0 6px;
`;

export const UploadImageLabel = styled.label`
  ${({ theme }) => css`
    width: 160px;
    height: 160px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_2};
    cursor: pointer;
  `}
`;
export const ProfileEditWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;

export const ExpressionDeleteButton = styled(IconButtonWrapper)`
  position: absolute;
  top: -8px;
  right: -8px;
  border-radius: 50%;
  background: ${(props) => props.theme.themeColor.negative};
`;

export const PersonaContainer = styled.div`
  margin-top: 16px;
`;

export const PersonaTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 4px;
  border: 1px solid ${(props) => props.theme.stroke.stroke_1};
  gap: 4px;
  border-radius: 23px;
`;
export const PersonaTypeButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 8px 0;
    border: 1px solid ${theme.backgroundColor.bg_light_5_alpha};
    border-radius: 19px;
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body16_bold};
    text-transform: capitalize;

    &.on {
      background: ${theme.backgroundColor.bg_light_1};
      color: ${theme.content.content_dark_1};
    }
  `}
`;

export const ContentSubTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body14_medium};
  `}
`;

export const ContentSubDesc = styled.p`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.content.content_light_5};
    ${theme.fontStyle.text.caption_medium};
  `}
`;

export const TopDetailWrapper = styled.div`
  display: flex;
  position: sticky;
  z-index: 1;
  top: ${(props) => props.theme.layout.chat_header_height};
  flex-direction: column;
  width: 100%;
  padding: 8px 16px 32px 16px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.6);
  background: ${(props) => props.theme.backgroundColor.base};
  gap: 16px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const ProfileWrapper = styled.div`
  flex-shrink: 0;
  width: 60px;
  height: 60px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
  }
`;

export const CharacterDetail = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 8px;
`;
export const CharacterName = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

export const CharacterHello = styled.div`
  height: 34px;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 17px 17px 17px 4px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 0px 16px 0px rgba(255, 255, 255, 0.25) inset;
  word-break: break-all;
  backdrop-filter: blur(25px);
  ${({ theme }) => theme.mixins.text.ellipsis_1};
`;

export const ButtonBox = styled.div`
  width: 110px;
`;

export const DeleteButton = styled.button`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.title.section18_medium}
  `}
`;

export const OpeningButton = styled.button`
  ${({ theme }) => css`
    width: 100%;
    height: 40px;
    border-radius: 8px;
    color: ${theme.content.content_dark_1};

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;

      & > span {
        ${theme.fontStyle.text.body16_medium}
        color: ${theme.content.content_dark_1};
      }
    }

    &.direction {
      background: ${theme.themeColor.main_1};
    }

    &.user_name {
      background: #ffcc4a;
    }
  `}
`;

export const CheckList = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const CheckBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
`;

export const Terms = styled.label`
  ${({ theme }) => css`
    position: relative;
    width: calc(100% - 44px);
    margin-left: 12px;

    span {
      display: block;
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.content.content_light_2};
    }
  `}
`;
